module.exports = __webpack_public_path__ + "static/media/Recurso 3.cdc5d84f.svg";